import { AppState } from '../../app/state/AppState';

export function selectFlowsOnSiteEnabled(state: AppState) {
  return state.session && state.session.info && state.session.info.site &&
    state.session.info.site.flowsOnSiteEnabled !== false;
}
